import styled from 'styled-components'
import { Text } from 'components/Text'

export const ProgramListContainer = styled.div`
  min-width: 995px;
  display: flex;
  flex-direction: column;
`
export const ProgramListItemText = styled(Text)`
  font-weight: 500;
  font-size: 1rem;
  line-height: 1rem;
`
export const ProgramListSpinnerContainer = styled.div`
  /* width: 100%; */
  background: red;
  /* display: flex;
    justify-content: center; */
  text-align: center;
  margin-top: 25px;
`
export const ProgramListItemActions = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.675rem 0 0;
`

export const ProgramListButtonContainer = styled.div`
  margin-right: 20px;
`

export const ProgramListHeaderContainer = styled.div`
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ProgramSwitcherContainer = styled.div`
  display: flex;
  justify-content: 'center';
  align-items: 'center';
`
export const ProgramSwitcherLabel = styled.h3`
  margin: 0;

  margin-right: 15px;
`
export const ProgramSwitcher = styled.div`
  margin-top: 4px;
`
